export default __webpack_public_path__ + "static/iwd-81ee1eaf5ccc2eb1cac5626092762562.jpg";